export enum EmployeeAccessLevel {
    none = 1,
    newbie = 2,
    developer = 3,
    fullAccess = 4,
}

export const getIssueEmployeeAccessLevelNameRu = (lvl: EmployeeAccessLevel) => {
    switch (lvl) {
        case EmployeeAccessLevel.none: return 'Без доступа';
        case EmployeeAccessLevel.newbie: return 'Новичок';
        case EmployeeAccessLevel.developer: return 'Разработчик';
        case EmployeeAccessLevel.fullAccess: return 'Полный доступ';
        default: return 'неизвестен';
    }
}